import VideosApi from '../api/videos';
import ActivitiesApi from '../api/activities';

export default {
  namespaced: true,
  state: {
    selectedVideo: null,
    personalizedCurriculum: {
      videoActivities: [],
      systemRecommendedActivities: [],
    },
    extrinsicData: null,
    videoScores: null,
    overallScore: null,
  },
  getters: {
    personalizedCurriculum(state) {
      return state.personalizedCurriculum;
    },
    selectedVideo(state) {
      return state.selectedVideo;
    },
    videoAnalyzed(state) {
      return state.selectedVideo && state.selectedVideo.status === 'Analyzed';
    },
    videoLanguage(state) {
      return state.selectedVideo && state.selectedVideo.language;
    },
    videoScores(state) {
      return state.videoScores;
    },
    overallScore(state) {
      return state.overallScore;
    },
  },
  actions: {
    async getSelectedVideo(context, videoId) {
      const video = await VideosApi.getUserVideo(videoId);

      context.commit('SET_SELECTED_VIDEO', video);
      context.commit('videos/SET_SELECTED_VIDEO', video, { root: true });

      return video;
    },
    async getVideoScores(context, videoId) {
      const data = await VideosApi.getImpactScores(videoId);

      context.commit('SET_VIDEO_SCORES', data.videoScores);
      context.commit('SET_OVERALL_SCORE', data.overallScore);
    },
    async getPersonalizedCurriculum(context, { videoId, language }) {
      await context.dispatch('videoAnalysis/getVideoScores', videoId, { root: true });
      const videoActivities = await ActivitiesApi.getVideoActivities(videoId);

      const systemRecommendedActivities = await ActivitiesApi.computePersonalized({
        language,
        scores: context.state.videoScores.reduce((carry, score) => ({
          ...carry,
          [score.name]: score.score,
        }), {}),
      });

      const curriculum = {
        videoActivities,
        systemRecommendedActivities,
      };

      context.commit('SET_PERSONALIZED_CURRICULUM', curriculum);
    },
  },
  mutations: {
    SET_SELECTED_VIDEO: (state, video) => {
      state.selectedVideo = video;
    },
    SET_OVERALL_SCORE: (state, overallScore) => {
      state.overallScore = overallScore;
    },
    SET_VIDEO_SCORES: (state, videoScores) => {
      state.videoScores = videoScores;
    },
    SET_PERSONALIZED_CURRICULUM: (state, curriculum) => {
      state.personalizedCurriculum = curriculum;
    },
  },
};
